export const getPanelId = (value: string): string => {
  return `panel-${value}`;
};

export const getTabId = (value: string): string => {
  return `tab-${value}`;
};
